module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-1.42756b31.jpg";